const queryBuilder = 'QueryBuilder';

/** Base Query Actions */
export const INITIALIZE_QUERY = `${queryBuilder}/INITIALIZE_QUERY`;
export const INITIALIZE_QUERY_RESPONSE = `${queryBuilder}/INITIALIZE_QUERY_RESPONSE`;
export const VALIDATE_QUERY = `${queryBuilder}/VALIDATE_QUERY`;
export const VALIDATE_QUERY_RESPONSE = `${VALIDATE_QUERY}_RESPONSE`;
export const UNDO_QUERY = `${queryBuilder}/UNDO_QUERY`;
export const REDO_QUERY = `${queryBuilder}/REDO_QUERY`;
export const TOGGLE_EDIT_MODE = `${queryBuilder}/TOGGLE_EDIT_MODE`;
export const TOGGLE_VIEW_MODE = `${queryBuilder}/TOGGLE_VIEW_MODE`;
export const UPDATE_QUERY = `${queryBuilder}/UPDATE_QUERY`;
export const UPDATE_QUERY_FROM_STATE = `${queryBuilder}/UPDATE_QUERY_FROM_STATE`;
export const UPDATE_QUERY_ERROR = `${queryBuilder}/UPDATE_QUERY_ERROR`;

export const FETCH_QUERY = `${queryBuilder}/FETCH_QUERY`;
export const FETCH_QUERY_ERROR = `${FETCH_QUERY}_ERROR`;
export const FETCH_QUERY_RESPONSE = `${FETCH_QUERY}_RESPONSE`;

export const FETCH_QUERY_PROPERTIES = `${FETCH_QUERY}_PROPERTIES`;
export const FETCH_QUERY_PROPERTIES_ERROR = `${FETCH_QUERY_PROPERTIES}_ERROR`;
export const FETCH_QUERY_PROPERTIES_RESPONSE = `${FETCH_QUERY_PROPERTIES}_RESPONSE`;

export const UPDATE_FIELDS_FOR_PROPERTY = `${queryBuilder}/UPDATE_FIELDS_FOR_PROPERTY`;
export const UPDATE_FIELDS_FOR_PROPERTY_ERROR = `${UPDATE_FIELDS_FOR_PROPERTY}_ERROR`;
export const UPDATE_FIELDS_FOR_PROPERTY_RESPONSE = `${UPDATE_FIELDS_FOR_PROPERTY}_RESPONSE`;

export const UPDATE_OPTIONS_FOR_FIELD = `${queryBuilder}/UPDATE_OPTIONS_FOR_FIELD`;
export const UPDATE_OPTIONS_FOR_FIELD_ERROR = `${UPDATE_OPTIONS_FOR_FIELD}_ERROR`;
export const UPDATE_OPTIONS_FOR_FIELD_RESPONSE = `${UPDATE_OPTIONS_FOR_FIELD}_RESPONSE`;

export const CHANGE_QUERY_ORDER_BY = `${queryBuilder}/CHANGE_QUERY_ORDER_BY`;
export const CHANGE_QUERY_SIZE_LIMIT = `${queryBuilder}/CHANGE_QUERY_SIZE_LIMIT`;
export const SET_USES_SMART_RECOS = `${queryBuilder}/SET_USES_SMART_RECOS`;

export const RESET_QUERY_BUILDER = `${queryBuilder}/RESET_QUERY_BUILDER`;

/** Criteria Property Actions */
export const ADD_CRITERIA_PROPERTY = `${queryBuilder}/ADD_CRITERIA_PROPERTY`;
export const UPDATE_CRITERIA_PROPERTIES = `${queryBuilder}/UPDATE_CRITERIA_PROPERTIES`;
export const COPY_CRITERIA_PROPERTY = `${queryBuilder}/COPY_CRITERIA_PROPERTY`;
export const DELETE_CRITERIA_PROPERTY = `${queryBuilder}/DELETE_CRITERIA_PROPERTY`;

export const CHANGE_CAST_TYPE = `${queryBuilder}/CHANGE_CAST_TYPE`;
export const CHANGE_COMBINATOR = `${queryBuilder}/CHANGE_COMBINATOR`;
export const CHANGE_COMPARATOR = `${queryBuilder}/CHANGE_COMPARATOR`;
export const CHANGE_DYNAMIC_VALUE = `${queryBuilder}/CHANGE_DYNAMIC_VALUE`;
export const CHANGE_FIELD = `${queryBuilder}/CHANGE_FIELD`;
export const CHANGE_GEO_VALUE = `${queryBuilder}/CHANGE_GEO_VALUE`;
export const CHANGE_PROPERTY = `${queryBuilder}/CHANGE_PROPERTY`;
export const CHANGE_PROPERTY_REFINEMENT = `${queryBuilder}/CHANGE_PROPERTY_REFINEMENT`;
export const CHANGE_VALUE = `${queryBuilder}/CHANGE_VALUE`;
export const CLEAR_VALUE = `${queryBuilder}/CLEAR_VALUE`;
export const TOGGLE_DYNAMIC = `${queryBuilder}/TOGGLE_DYNAMIC`;

/** Search Query Actions */
export const ADD_SEARCH_QUERY = `${queryBuilder}/ADD_SEARCH_QUERY`;
export const UPDATE_SEARCH_QUERY = `${queryBuilder}/UPDATE_SEARCH_QUERY`;
export const COPY_SEARCH_QUERY = `${queryBuilder}/COPY_SEARCH_QUERY`;
export const DELETE_SEARCH_QUERY = `${queryBuilder}/DELETE_SEARCH_QUERY`;
export const MOVE_SEARCH_QUERY = `${queryBuilder}/MOVE_SEARCH_QUERY`;
export const REORDER_SEARCH_QUERY = `${queryBuilder}/REORDER_SEARCH_QUERY`;

/** Add Search Group Actions */
export const ADD_SEARCH_GROUP = `${queryBuilder}/ADD_SEARCH_GROUP`;
export const CHANGE_SEARCH_GROUP_COMBINATOR = `${queryBuilder}/CHANGE_SEARCH_GROUP_COMBINATOR`;
export const COPY_SEARCH_GROUP = `${queryBuilder}/COPY_SEARCH_GROUP`;
export const DELETE_SEARCH_GROUP = `${queryBuilder}/DELETE_SEARCH_GROUP`;
export const UPDATE_SEARCH_GROUP = `${queryBuilder}/UPDATE_SEARCH_GROUP`;

/** Cloning Actions */
export const SET_CLONING_VALIDATION_MESSAGES = `${queryBuilder}/SET_CLONING_VALIDATION_MESSAGES`;

/** Catalog Actions */
export const CHANGE_CATALOG_NAME = `${queryBuilder}/CHANGE_CATALOG_NAME`;
